import { common, locationMst, mstCommon } from '@libs/domain';
import { mstListSearchFieldConfig, mstRegistrationFieldConfig } from '@libs/templates/mst';
import { Item } from '@ps-smart-cp/ppfw-client';

const locationMstRegistrationFieldConfig = {
  ...mstRegistrationFieldConfig,
  code: Item.of(mstCommon.names.code, locationMst.attributes.locationMstCode),
  address: Item.of(common.names.address, common.attributes.address),
};

const locationMstListSearchFieldConfig = {
  ...mstListSearchFieldConfig,
  address: Item.of(common.names.address, common.attributes.address),
};

const locationMstSettingFieldConfig = {
  displayName: Item.of(mstCommon.names.displayName, mstCommon.attributes.displayName.replaceRequired(false)),
  codeDigits: Item.of(mstCommon.names.codeDigits, mstCommon.attributes.codeDigits.replaceRequired(false)),
  isUsed: Item.of(common.names.isUsed, common.attributes.isUsed),
};

const locationMstSettingFieldConfigForCheck = {
  displayName: Item.of(mstCommon.names.displayName, mstCommon.attributes.displayName),
  codeDigits: Item.of(mstCommon.names.codeDigits, mstCommon.attributes.codeDigits),
};

export {
  locationMstListSearchFieldConfig,
  locationMstRegistrationFieldConfig,
  locationMstSettingFieldConfig,
  locationMstSettingFieldConfigForCheck,
};
